import React from 'react';
import { useLocation } from 'react-router';

import { NavMenu, NavMenuItem } from '../../../components/nav-menu';

type MenuOptions = {
  key: string;
  label: string;
  href: string;
  external?: boolean;
};

type SpaceSettingsMenuProps = {
  items: MenuOptions[];
};

export const SettingsMenu: React.FC<SpaceSettingsMenuProps> = ({ items }) => {
  const location = useLocation() as { state: { prevPath: string } };
  const pathname = window.location.pathname.split('/');

  return (
    <NavMenu>
      {items.map(({ key, label, href, external }) => (
        <NavMenuItem
          key={key}
          to={href}
          label={label}
          external={external}
          state={location.state}
          isActive={
            !external && ((pathname.length === 4 && key === 'general') || pathname.includes(key))
          }
        />
      ))}
    </NavMenu>
  );
};
